<script>
import conTraining from 'gkConUI/con-training'
import utils from '@/utils'

export default {
  data () {
    return {
    }
  },
  components: {
    conTraining
  },
  props: [
    'id'
  ],
  computed: {
    lecture () {
      return this.$store.state.lectures[this.id] || {
        speaker: {},
        relativeLectureIds: [],
        speakerIds: [],
        relativeManualLectureIds: []
      }
    }
  },
  updated () {
    utils.weixinshare({
      imgUrl: this.lecture.speaker.avatar,
      title: this.lecture.title + this.$store.state.config.wechat_share.default_title
    })
  },
  mounted () {
    utils.weixinshare({
      imgUrl: this.lecture.speaker.avatar,
      title: this.lecture.title + this.$store.state.config.wechat_share.default_title
    })
  },
  render () {
    return (<con-training {...{ props: { id: this.id } }}/>)
  }
}
</script>
